<template>
    <div
        id="app-router"
        class="fin-container-fluid app-router fin-sticky fin-top-[-1px] fin-transition-all fin-duration-500 fin-ease-in-out fin-z-10"
    >
        <div class="mobile-router md:fin-hidden fin-z-30 fin-relative">
            <el-select
                v-model="currentRoute"
                class="fin-w-full"
                placeholder="Select to change stage"
                filterable
                @change="routeChange"
            >
                <el-option v-if="route.visible" v-for="route in routes" :key="route.to" :value="route.to">
                    <div class="fin-flex fin-justify-between fin-items-center">
                        <span v-html="route.name.replace('<br />', '')"></span>
                        <font-awesome-icon :icon="route.icon" />
                    </div>
                </el-option>
            </el-select>
        </div>

        <div class="desktop-router fin-hidden md:fin-block fin--mb-[1px] fin-relative fin-z-30">
            <nav class="fin-flex fin-h-[90px] fin--mx-0.5 fin-content-center fin-items-end" aria-label="Tabs">
                <router-link
                    v-if="route.visible"
                    v-for="route in routes"
                    :key="route.to"
                    :to="{ name: route.to }"
                    :title="route.name.replace('<br />', '')"
                    class="route-link fin-border-b-0 fin-mx-0.5 fin-rounded-t-md fin-h-[80px] hover:fin-h-[85px] hover:fin-bg-white fin-transition-all fin-duration-500 fin-ease-in-out fin-text-gray-900 fin-relative fin-min-w-0 fin-flex-1 fin-overflow-hidden fin-py-4 fin-px-4 fin-text-sm fin-font-medium fin-text-center fin-border"
                    :class="[route.class, { active: route.active }, { 'fin-bg-secondary': route.active }]"
                >
                    <div
                        class="router-link-wrapper fin-text-white fin-h-full fin-flex fin-justify-end md:fin-justify-center xl:fin-justify-between fin-items-center xl:fin-items-left fin-text-center xl:fin-text-left fin-flex-col-reverse xl:fin-flex-row fin-transition-all fin-duration-500 fin-ease-in-out"
                    >
                        <span class="fin-relative md:fin-z-20 fin-text-xs xl:fin-text-sm" v-html="route.name"></span>
                        <font-awesome-icon
                            :icon="route.icon"
                            class="md:fin-text-5xl xl:fin-text-xl md:fin-opacity-10 xl:fin-opacity-100 md:fin-z-10 md:fin-absolute xl:fin-relative"
                        />
                    </div>
                </router-link>
            </nav>
        </div>

        <div
            v-if="_.size(applicants)"
            class="fin-px-1.5 md:fin-px-0 customer-actions fin-transition-all fin-duration-500 fin-ease-in-out fin-opacity-0 fin--mt-[55px] fin-relative fin-w-full fin-z-20 fin-py-2 fin-border fin-border-t-0 fin-border-b-0 fin-bg-white fin-flex fin-flex-col md:fin-flex-row fin-justify-center fin-items-center"
        >

            <div v-for="(applicant, applicantIndex) in applicants" class="fin-flex fin-items-center">
                <div class="fin-inline-flex fin-rounded-md fin-mx-0.5">
                    <button
                        @click="changeApplicant($event, applicantIndex)"
                        type="button"
                        class="fin-hidden md:fin-inline-flex fin-min-w-[115px] fin-justify-center fin-relative fin-items-center fin-rounded-l-md fin-border fin-border-white fin-px-4 fin-py-2 fin-text-sm fin-font-medium fin-text-white focus:fin-z-10"
                        :class="application.active_applicant == applicantIndex ? 'fin-bg-primary' : 'fin-bg-extra'"
                    >
                        Applicant {{ applicantIndex + 1 }}
                    </button>
                    <button
                        @click="changeApplicant($event, applicantIndex)"
                        type="button"
                        class="fin-min-w-[200px] fin-rounded-l-md md:fin-rounded-l-none fin-justify-center fin-relative fin--ml-px fin-inline-flex fin-items-center fin-border fin-border-white fin-px-4 fin-py-2 fin-text-sm fin-font-medium fin-text-white focus:fin-z-10"
                        :class="[
                            application.active_applicant == applicantIndex
                                ? 'fin-bg-primary'
                                : 'fin-bg-extra md:fin-bg-primary',

                            !applicant.phone && !applicant.email ? 'fin-rounded-r-md' : ''
                        ]"
                    >
                        {{ applicant.full_name || "New Applicant" }}
                    </button>
                    <button
                        type="button"
                        v-if="_.get(applicant, 'phone', false)"
                        class="fin-relative fin--ml-px fin-inline-flex fin-items-center fin-border fin-border-white fin-bg-secondary fin-px-4 fin-py-2 fin-text-sm fin-font-medium fin-text-white focus:fin-z-10"
                        :class="[!applicant.email ? 'fin-rounded-r-md' : '']"
                    >
                        <el-tooltip class="item" effect="dark" :content="applicant.phone" placement="top">
                            <a :href="`tel:${applicant.cx_phone}`">
                                <font-awesome-icon :icon="['fas', 'phone']" class="fin-text-white fa-xs" />
                            </a>
                        </el-tooltip>
                    </button>
                    <button
                        type="button"
                        v-if="_.get(applicant, 'email', false)"
                        @click="sendEmail(applicant.email)"
                        class="fin-relative fin--ml-px fin-inline-flex fin-items-center fin-rounded-r-md fin-border fin-border-white fin-bg-secondary fin-px-4 fin-py-2 fin-text-sm fin-font-medium fin-text-white focus:fin-z-10"
                    >
                        <el-tooltip class="item" effect="dark" :content="applicant.email" placement="top">
                            <font-awesome-icon :icon="['fas', 'envelope']" class="fin-text-white fa-xs" />
                        </el-tooltip>
                    </button>
                </div>
                <template v-if="allowApplicantSwap && applicantIndex == 0">
                    <div
                        class="swap-switch fin-absolute md:fin-relative fin-right-0 fin-top-[32px] md:fin-right-auto md:fin-top-auto fin-px-1.5"
                        @click="swapApplicantTrigger($event)"
                        :key="'swapper-' + applicantIndex"
                    >
                        <font-awesome-icon :icon="['fas', 'fa-exchange']" class="fin-text-primary" />
                    </div>
                </template>
            </div>
        </div>

        <!-- el-color-picker v-model="color1" class="fin-fi"></el-color-picker -->

        <div
            v-if="
                (Ambition.Globals.tenant.user.roles.some((role) => role.name == 'administrator') &&
                    _.size(usersViewingApp) > 1) ||
                _.size(usersViewingApp.filter((u) => !u.roles.some((role) => role.name == 'administrator'))) > 1
            "
            class="fixed-viewers-list"
        >
            <el-tooltip
                v-for="(user, index) in usersViewingApp"
                :key="index"
                class="item"
                effect="dark"
                :content="user.full_name"
                placement="top-start"
                :class="{
                    'd-none':
                        user.roles.some((role) => role.name == 'administrator') &&
                        !Ambition.Globals.tenant.user.roles.some((role) => role.name == 'administrator'),
                }"
            >
                <el-avatar
                    :style="`background:${getColour(user.full_name)}`"
                    :class="{
                        batman:
                            user.roles.some((role) => role.name == 'administrator') &&
                            Ambition.Globals.tenant.user.roles.some((role) => role.name == 'administrator'),
                    }"
                >
                    {{ getInitials(user.full_name) }}
                </el-avatar>
            </el-tooltip>
        </div>

        <x-modal
            :wWidth="400"
            v-if="showTakeControlRequest.show"
            cancelText="Disallow"
            okText="Allow"
            @ok="allowControl(showTakeControlRequest.data)"
            @cancel="disallowControl(showTakeControlRequest.data)"
            :hideClose="true"
        >
            <div slot="title" :class="`truncate`">
                {{ showTakeControlRequest.title }}
            </div>
            <div class="">
                {{ showTakeControlRequest.message }}
            </div>
            <el-input
                class="mt-3"
                type="textarea"
                :rows="2"
                placeholder="Optional message"
                v-model="showTakeControlRequest.data.message"
            ></el-input>
        </x-modal>

        <x-modal
            :wWidth="400"
            v-if="showRequestControlModal.show"
            @ok="showRequestControlModal.show = false"
            :hideCancel="false"
            @cancel="showRequestControlModal.show = false"
            :okText="showRequestControlModal.pending ? `Pending...` : showRequestControlModal.buttonText"
            :okDisabled="showRequestControlModal.pending"
            :hideClose="true"
        >
            <div slot="title" :class="`truncate`">
                {{ showRequestControlModal.title }}
            </div>
            <div class="">
                {{ _.get(showRequestControlModal, "message", "Request for control denied") }}
            </div>
        </x-modal>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex"
import { GlobalEventBus } from "@tenant/shared/GlobalEventBus"

export default {
    name: "AppRouter",
    data() {
        return {
            // color1: null,
            currentRoute: null,
            autoAllowTimeout: null,
            showTakeControlRequest: {
                show: false,
                title: "",
                message: "",
                data: {
                    message: "",
                },
            },
            showRequestControlModal: {
                show: false,
                title: "",
                message: "",
                pending: true,
                user: "",
                buttonText: "Continue",
            },
            applicationSocket: null,
        }
    },

    computed: {
        ...mapGetters({
            application: "appStore/application/get",
            applicants: "appStore/application/applicants/get",
            options: "appStore/options/get",
            user: "appStore/auth/user/get",
            isReferrer: "appStore/auth/user/isReferrer",
            isAcrReferrerExt: "appStore/auth/user/isAcrReferrerExt",
            usersViewingApp: "statusIndicators/usersViewingApp",
            editLockUser: "editLockUser",
        }),
        qualifyingQuestionnaireFinalised() {
            return _.has(this.application.qualifying_questionnaire, "finalised", false) &&
                this.application.qualifying_questionnaire.finalised
                ? true
                : false
        },
        allowApplicantSwap() {
            let editLockUser = _.get(this.$store.getters, "editLock")
            let brokerId = !_.isNull(editLockUser) ? editLockUser : _.get(this.$store.getters, "broker_id")
            return (
                _.size(this.applicants) > 1 &&
                _.get(this.application, 'application_status_id') < 14 &&
                this.application.status != 3 &&
                Ambition.Globals.tenant.user.id === brokerId
            )
        },
        routes() {
            return [
                {
                    to: "Application",
                    name: "Application",
                    icon: ["fas", "user-alt"],
                    class: _.get(this.application, 'application_status_id') > 2 ? "fin-bg-primary-dark" : "fin-bg-primary",
                    visible: this.isRouteVisible('application'),
                    active: _.get(this.application, 'application_status_id') == 1 || !_.get(this.application, 'application_status_id') ? true : false,
                },
                {
                    to: "Loan Details",
                    name: Ambition.isAmbition() ? "Lender <br /> Submission" : "Submission",
                    icon: ["fas", "briefcase"],
                    class: _.get(this.application, 'application_status_id') > 3 ? "fin-bg-primary-dark" : "fin-bg-primary",
                    visible: this.isRouteVisible('loan-details'),
                    active: _.get(this.application, 'application_status_id') == 3 ? true : false,
                },
                {
                    to: "Loan Submission",
                    name: "Lender <br /> Approval",
                    icon: ["fas", "clipboard-check"],
                    class: _.get(this.application, 'application_status_id') > 4 ? "fin-bg-primary-dark" : "fin-bg-primary",
                    visible: this.isRouteVisible('loan-submission'),
                    active: _.get(this.application, 'application_status_id') == 4 ? true : false,
                },
                {
                    to: "Asset and Seller",
                    name: "Asset & <br /> Seller",
                    icon: ["fas", "shopping-basket"],
                    class: _.get(this.application, 'application_status_id') > 5 ? "fin-bg-primary-dark" : "fin-bg-primary",
                    visible: this.isRouteVisible('asset-seller'),
                    active: _.get(this.application, 'application_status_id') == 5 ? true : false,
                },
                {
                    to: "Loan Package",
                    name: "Loan <br /> Package",
                    icon: ["fas", "list-ol"],
                    class: _.get(this.application, 'application_status_id') > 7 ? "fin-bg-primary-dark" : "fin-bg-primary",
                    visible: this.isRouteVisible('loan-package'),
                    active: _.get(this.application, 'application_status_id') == 7 ? true : false,
                },
                {
                    to: "Send and Settle",
                    name: "Send & <br /> Settle",
                    icon: ["fas", "paper-plane"],
                    class: _.get(this.application, 'application_status_id') > 9 ? "fin-bg-primary-dark" : "fin-bg-primary",
                    visible: this.isRouteVisible('send-settle'),
                    active: _.get(this.application, 'application_status_id') == 9 ? true : false,
                },
                {
                    to: "Loan Summary",
                    name: Ambition.isAmbition() ? "Final Loan <br /> Summary" : "Settlement",
                    icon: ["fas", "list-ul"],
                    class: _.get(this.application, 'application_status_id') > 13 ? "fin-bg-primary-dark" : "fin-bg-primary",
                    visible: this.isRouteVisible('loan-summary'),
                    active: _.get(this.application, 'application_status_id') == 13 ? true : false,
                },
                {
                    to: "Conditioning",
                    name: "Documents",
                    icon: ["fas", "paste"],
                    class: "fin-bg-extra",
                    visible: this.isRouteVisible('conditioning'),
                    active: _.get(this.application, 'application_status_id') == 2 ? true : false,
                },
            ]
        },
    },

    mounted() {

        // observe the router and fix
        const appRouter = document.querySelector(".app-router")
        const topNav = document.getElementById("js-amb-top-nav")

        const observer = new IntersectionObserver(
            ([e]) => {
                e.target.classList.toggle("is-pinned", e.intersectionRatio < 1)
                topNav.classList.toggle("hide-nav", e.intersectionRatio < 1)
            },
            {
                threshold: [1],
            }
        )
        observer.observe(appRouter)

        // set the application socket listener and listen
        this.applicationSocket = Echo.private("viewing." + Ambition.getGlobal("tenant.tenantName") + "." + this.application.id)
        this.applicationSocket
            .listen(".updates", (e) => {})
            .listenForWhisper("requestControl", (e) => {
                let editLockUser = _.get(this.$store.getters, "editLock")
                let brokerId = !_.isNull(editLockUser) ? editLockUser : _.get(this.$store.getters, "broker_id")

                if (Ambition.Globals.tenant.user.id == brokerId) {
                    this.showTakeControlRequest = {
                        show: true,
                        title: "Allow control?",
                        message: `${_.get(e, "user.first_name", "A user")} ${_.get(
                            e,
                            "user.last_name",
                            ""
                        )} has requested control of this application.`,
                        data: e,
                    }

                    this.setTimer()
                }
            })
            .listenForWhisper("allowControl", (e) => {
                clearTimeout(this.autoAllowTimeout)
                if (Ambition.Globals.tenant.user.id == e.user.id) {
                    this.controlAllowed(e)
                }
            })
            .listenForWhisper("disallow", (r) => {
                clearTimeout(this.autoAllowTimeout)
                if (Ambition.Globals.tenant.user.id == r.user.id) {
                    this.disallowed(r)
                }
            })

        Echo.private(`syncApplication.${Ambition.tenantId()}.${this.application.id}`).listen(".sync", (event) => {
            this.$store.dispatch("syncApplication")
        })

        this.$store.dispatch("updateEditLockUser", this.application.edit_lock_user)

        let applicationWebsocketPresence = Echo.join("viewing." + Ambition.tenantId() + "." + this.application.id)

        applicationWebsocketPresence
            .here((users) => {
                this.$store.dispatch("statusIndicators/usersViewingApp", users)
            })
            .joining((user) => {
                this.usersViewingApp.push(user)
                if (
                    !user.roles.some((role) => role.name == "administrator") &&
                    !Ambition.Globals.tenant.user.roles.some((role) => role.name == "administrator")
                ) {
                    this.$notify.success({
                        message: `${user.full_name} is now viewing this app.`,
                        type: "success",
                        showClose: false,
                        position: "bottom-left",
                        offset: 45,
                    })
                }
            })
            .leaving((user) => {
                this.$store.dispatch(
                    "statusIndicators/usersViewingApp",
                    this.usersViewingApp.filter((u) => u.id !== user.id)
                )
                if (
                    !user.roles.some((role) => role.name == "administrator") &&
                    !Ambition.Globals.tenant.user.roles.some((role) => role.name == "administrator")
                ) {
                    this.$notify.success({
                        message: `${user.full_name} has stopped viewing this app.`,
                        type: "success",
                        showClose: false,
                        position: "bottom-left",
                        offset: 45,
                    })
                }
            })

        this.$bus.$on("requestControl", (data) => {
            let editLockUser = _.get(this.$store.getters, "editLock")
            let brokerId = !_.isNull(editLockUser) ? editLockUser : _.get(this.$store.getters, "broker_id")

            if (Ambition.Globals.tenant.user.id !== brokerId) {
                this.applicationSocket.whisper("requestControl", data)

                let broker = this.editLockUser
                broker = _.get(broker, "full_name", "Fintelligence Support")

                if (this.user.id == data.user.id) {
                    this.showRequestControlModal = {
                        show: true,
                        title: "Requesting Control",
                        message: `App currently locked to ${broker}, a request has been sent for control.`,
                        pending: true,
                    }
                }
            }
        })

        this.$bus.$on("allowControl", (data) => {
            this.allowControl(data)
        })

        this.$bus.$on("disallowControl", (data) => {
            this.disallowControl(data)
        })

        this.$bus.$on("takeControl", (data) => {
            this.takeControl(data)
        })
    },

    methods: {
        isRouteVisible(route) {
            switch(route) {
                case 'application':
                case 'conditioning':
                    return true
                    break;
                case 'loan-details':
                        return this.isReferrer ? ( this.isAcrReferrerExt ? true : false) : true
                    break;
                case 'loan-summary':
                    if (Ambition.qualifyingQuestionnaireEnabled() && !this.qualifyingQuestionnaireFinalised) {
                        return false
                    } else if (this.isReferrer){
                        return false
                    }else {
                        return Ambition.isAmbition() ? (this.isReferrer ? false : true) : true
                    }
                    break;
                case 'loan-package':
                    if (Ambition.qualifyingQuestionnaireEnabled() && !this.qualifyingQuestionnaireFinalised) {
                        return false
                    } else {
                        return Ambition.isAmbition() ? (this.isReferrer ? false : true) : Ambition.enableLoanOptionsAmbitionCloud() ? true : false
                    }
                    break;
                case 'loan-submission':
                case 'asset-seller':
                case 'send-settle':
                    if (Ambition.qualifyingQuestionnaireEnabled() && !this.qualifyingQuestionnaireFinalised) {
                        return false
                    } else {
                        return Ambition.isAmbition() ? (this.isReferrer ? false : true) : false
                    }
                    break;
            }
        },
        routeChange(route) {
            this.$router.push({ name: route })
        },
        setTimer() {
            this.autoAllowTimeout = setTimeout(() => {
                this.allowControl(e)
            }, 30000)
        },
        sendEmail(e) {
            this.$bus.$emit("open-create-modal", {
                selected: "Send Message",
                defaultEmailTemplate: "New Blank Email",
            })
        },
        changeApplicant(event, applicantIndex) {
            this.$store.getters.initAppData.active_applicant = applicantIndex
            this.$appStore.application.applicants.setActive(applicantIndex)

            let location =
                this.application.application_type_id == 2 ? `commercial-applicant-information` : `consumer-applicant-information`
            this.$bus.$emit("jumpToSection", [event, location])

            this.$bus.$emit("switchApplicant", applicantIndex)
        },
        allowControl(e) {
            GlobalEventBus.$emit("saveApplication")
            this.applicationSocket.whisper("allowControl", {
                user: e.user,
                responder: this.user,
                message: _.get(
                    this.showTakeControlRequest,
                    "data.message",
                    "Your request has been granted, the app with now reload with the latest data."
                ),
            })

            this.$store.dispatch("updateEditLock", _.get(e.user, "id"))
            this.$store.dispatch("updateEditLockUser", e.user)

            this.showTakeControlRequest = {
                show: false,
                title: "",
                message: "",
                user: "",
                data: { message: "" },
            }
        },

        controlAllowed(e) {
            this.showRequestControlModal.title = `Control Granted`
            this.showRequestControlModal.message = _.get(e, "message")
            this.showRequestControlModal.pending = false
            this.showRequestControlModal.okButtonText = "Reloading application..."

            this.setEditLock(_.get(Ambition.Globals.tenant.user, "id")).then(() => {
                this.$message({
                    type: "success",
                    message: "Edit Mode Activated, refreshing application content",
                })
                setTimeout(() => {
                    window.location.reload()
                }, 2000)
            })
        },

        disallowed(e) {
            this.showRequestControlModal.title = `Control request denied by ${e.responder.first_name}`
            this.showRequestControlModal.message = _.get(e, "message")
            this.showRequestControlModal.pending = false
        },

        disallowControl(e) {
            this.applicationSocket.whisper("disallow", {
                user: e.user,
                responder: Ambition.Globals.tenant.user,
                message: _.get(this.showTakeControlRequest, "data.message"),
            })
            this.showTakeControlRequest = {
                show: false,
                title: "",
                message: "",
                user: "",
                data: { message: "" },
            }
        },

        takeControl: function () {
            if (this.editorOnline) {
                this.$bus.$emit("requestControl", { user: this.Ambition.Globals.tenant.user })
            } else {
                this.setEditLock(_.get(this.Ambition.Globals.tenant.user, "id")).then(() => {
                    this.$message({
                        type: "success",
                        message: "Edit Mode Activated",
                    })
                })
            }
        },

        async setEditLock(id) {
            let headers = { headers: { Authorization: "Bearer " + this.$store.getters.token } }
            let url = "/api/application/" + this.application.id
            let data = { update_edit_lock: true, edit_lock: id }

            let res
            try {
                res = await axios.patch(url, data, headers)
                this.$store.dispatch("updateEditLock", id)
                this.$store.dispatch("updateEditLockUser", res.data.user)
            } catch (e) {
                throw e
            }
        },

        canControlApp() {
            if (!_.get(this.Ambition.Globals.tenant, "editLockEnabled")) return true
            return (
                _.get(this.Ambition.Globals.tenant.user, "id") ==
                (!_.isNull(_.get(this.$store.getters, "editLock"))
                    ? _.get(this.$store.getters, "editLock")
                    : _.get(this.application, "broker_id"))
            )
        },

        swapApplicantTrigger(ev) {
            // check if user has control
            if (!this.allowApplicantSwap) return

            this.swappingApplicants = true

            // disable save if on application tab
            if (this.$route.name === "Application") {
                this.$bus.$on("saveApplication:end", () => {
                    this.$bus.$off("saveApplication:end")
                    this.swapApplicantAction()
                })
                this.$bus.$emit("saveApplication")
            } else {
                this.swapApplicantAction()
            }
        },

        swapApplicantAction() {
            swal({
                type: "warning",
                text: "This will swap applicant positions.",
                title: "Are you sure?",
                showCancelButton: true,
                cancelButtonText: "Cancel",
                cancelButtonColor: "#F44336",
                confirmButtonText: "Swap Positions",
                confirmButtonColor: "#284da5",
                reverseButtons: false,
            }).then((result) => {
                if (result.value) {
                    // make call to swap users
                    this.$tenant
                        .get("/api/application/" + Ambition.Globals.tenant.applicationId + "/swap-applicant")
                        .then((res) => {
                            // refresh applicaton on success
                            setTimeout(() => {
                                window.location.reload()
                            }, 300)
                        })
                        .finally(() => {
                            this.swappingApplicants = false
                        })
                } else {
                    this.swappingApplicants = false
                }
            })
        },
        getInitials(name) {
            return name
                .split(" ")
                .map((e) => e.charAt(0))
                .join("")
                .toUpperCase()
        },

        getColour(username, s = 30, l = 50) {
            var hash = 0
            for (var i = 0; i < username.length; i++) {
                hash = username.charCodeAt(i) + ((hash << 5) - hash)
            }

            var h = hash % 360
            return "hsl(" + h + ", " + s + "%, " + l + "%)"
        },
    },

    watch: {
        "$route.name": {
            handler(route) {
                this.currentRoute = route
            },
            immediate: true,
        },
        application: {
            handler() {
                // console.warn("this.application", this.application)
            },
            immediate: true,
            deep: true,
        },
        // color1: {
        //     handler(color1) {
        //         console.warn('color1', color1)
        //         if (color1) {
        //             document.documentElement.style.setProperty("--colors-primary", color1)
        //         }
        //     },
        //     immediate: false,
        // },
    },
}
</script>

<style lang="scss" scoped>
.app-router.is-pinned {
    @apply fin-p-0 md:fin--top-[10px] fin-bg-white fin-shadow #{!important}
}

.app-router .route-link.router-link-active {
    @apply fin-bg-white md:fin-h-[85px] #{!important}
}

.app-router.is-pinned .route-link.router-link-active {
    @apply fin-border-b #{!important}
}

.app-router.is-pinned .route-link {
    @apply fin-border-b #{!important}
}

.app-router.is-pinned nav {
    @apply fin-h-[90px] fin-px-1.5 #{!important}
}

.app-router .route-link:hover .router-link-wrapper {
    @apply fin-text-primary #{!important}
}

.router-link-active {
    .router-link-wrapper {
        @apply fin-text-primary #{!important}
    }
}

.app-router .route-link.active {
    @apply md:fin-h-[90px] #{!important}
}

.app-router.is-pinned .route-link {
    @apply fin-rounded-t-none fin-rounded-b-md md:fin-h-[80px] #{!important}
}

.app-router.is-pinned .customer-actions {
    @apply fin-opacity-100 fin-mt-0 fin-border-b #{!important}
}

.app-router.is-pinned .mobile-router {
    @apply fin-p-1.5 #{!important}
}

.fixed-viewers-list {
    position: fixed;
    bottom: 62px;
    left: 100px;
    z-index: 5;
    display: flex;
    align-items: flex-end;

    .el-avatar:not(:first-child) {
        margin-left: -7px;
        -webkit-mask: radial-gradient(circle 20px at -10px 50%, transparent 99%, #fff 100%);
        mask: radial-gradient(circle 20px at -10px 50%, transparent 99%, #fff 100%);
    }

    .el-avatar {
        &.batman {
            overflow: visible;
            position: relative;
            opacity: 0.7;

            &:after {
                content: "";
                position: absolute;
                top: -9px;
                left: -1px;
                z-index: 1;
                background-image: url("/images/decorations/batman.png");
                height: 40px;
                width: 42px;
                background-repeat: no-repeat;
            }
        }
    }
}
</style>
